<template>
  <div :id="`shortcode-next-matches`" v-if="matchesToShow.length > 2"
       class="pb-2.5 -mt-[7px]">
    <div class="border-y py-3 border-zt-light relative xl:border-x xl:rounded-zt">
      <div class="flex items-center justify-between px-2.5 xl:px-3">
        <span class="text-base text-zt-more uppercase font-medium">
          Inne proponowane mecze
        </span>
      </div>
      <div :id="`swiper-shortcode-mecze`" class="swiper pt-4">
        <div :id="`swiper-shortcode-mecze-wrapper`" class="swiper-wrapper pl-2.5 flex gap-x-[9px] xl:pl-3">
          <a v-for="match in matchesToShow" :href="`/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_team_query_name}/${match.visitorteam_team_query_name}/`"
             data-count-click="Inne proponowane mecze - w Nowej PN" data-count-click-category="football"
             class="no-default-style zt-hover swiper-slide py-[4px] px-[5px] border rounded-zt border-zt-more w-[92px] flex flex-col items-start last:mr-5">
            <p class="text-[10px] text-center w-full leading-[17px] font-normal text-zt-more">{{ getMatchDate(match.date) }}</p>
            <div class="pt-[1px] flex justify-center gap-x-1 max-h-[15px]">
              <TeamImg class="!w-[10px] !h-[10px] inline-block translate-y-[2px]" :team="getTeamForImg(match, 'local')"/>
              <div class="text-[10px] max-h-[15px] font-normal text-ellipsis break-all line-clamp-1"> {{ match.localteam_shortname !== '' ? match.localteam_shortname : match.localteam_name }} </div>
            </div>
            <div class="pt-[2px] flex justify-center gap-x-1 max-h-[15px]">
              <TeamImg class="!w-[10px] !h-[10px] inline-block translate-y-[2px]" :team="getTeamForImg(match, 'visitor')"/>
              <div class="text-[10px] max-h-[15px] font-normal text-ellipsis break-all line-clamp-1"> {{ match.visitorteam_shortname !== '' ? match.visitorteam_shortname : match.visitorteam_name }} </div>
            </div>
          </a>
        </div>
      </div>
      <div :class="`swiper-scrollbar-shortcode-mecze`"
           class="swiper-scrollbar !h-[2px] bg-[#3a4b6480] !cursor-default"></div>
    </div>
  </div>
</template>

<script>
import TeamImg from "../components/football_stats/blocks/TeamImg.vue";
import Swiper from "swiper";
import {FreeMode, Scrollbar} from "swiper/modules";

export default {
  name: 'OtherLeagueMatches',
  components: {TeamImg},
  inject: ['WP'],
  props: {
    leagueId: {
      type: Number,
      required: true
    },
    teamAId: {
      type: Number,
      required: true
    },
    teamBId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      matches: []
    }
  },
  mounted() {
    this.loadMatches();
  },
  computed: {
    matchesToShow() {
      return this.matches.slice(0, 6);
    }
  },
  methods: {
    getTeamForImg(match, type) {
      return {
        query_name: type === 'local' ? match.localteam_team_query_name : match.visitorteam_team_query_name,
        team_id: type === 'local' ? match.localteam_id : match.visitorteam_id,
        name: type === 'local' ? match.localteam_name : match.visitorteam_name
      }
    },
    getMatchDate(date) {
      date = DateTime.fromSQL(date);
      const today = DateTime.now();
      const dayDiff = Math.round(today.diff(date, 'days').days);
      if (dayDiff === 0) {
        return `${date.toFormat(`HH:mm`)}`;
      }
      if (dayDiff === -1) {
        return `Jutro, ${date.toFormat('HH:mm')}`;
      }
      return date.toFormat('dd.MM, HH:mm');
    },
    loadMatches() {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_league_matches',
        league_id: this.leagueId,
        status_array: ['NS'],
        order: 'ASC',
        qualification: false,
      }).then(res => {
        const rounds = Object.values(res.data.data);
        for (const round of rounds) {
          this.matches.push(...round.round_matches);
        }
        this.matches = this.matches.filter(match => (+match.localteam_id !== +this.teamAId && +match.visitorteam_id !== +this.teamBId)
            && (+match.localteam_id !== +this.teamBId && +match.visitorteam_id !== +this.teamAId));

        setTimeout(() => {
          new Swiper(`#swiper-shortcode-mecze`, {
            modules: [Scrollbar, FreeMode],
            slidesPerView: 'auto',
            resistanceRatio: 0,
            centeredSlides: window.size.mobile,
            centeredSlidesBounds: window.size.mobile,
            freeMode: {
              enabled: true,
              minimumVelocity: 0.01,
              momentum: true,
              momentumBounce: false,
              momentumRatio: 0.7,
              momentumVelocityRatio: 0.5,
              sticky: false,
            },
            scrollbar: {
              el: `.swiper-scrollbar-shortcode-mecze`,
              hide: true,
            },
            spaceBetween: 9,
          });
          document.querySelector(`#swiper-shortcode-mecze-wrapper`)?.classList.remove('gap-x-[9px]');
        }, 300)

      })
    }
  }
}
</script>

